/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_InInputs */



/**
* | output |
* | --- |
* | "Sign in" |
*
* @param {Common_Sign_InInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const common_sign_in = /** @type {((inputs?: Common_Sign_InInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_InInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Anmelden")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Se connecter")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("登录")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("登入")
	if (locale === "ko") return /** @type {LocalizedString} */ ("로그인")
	return /** @type {LocalizedString} */ ("Sign in")
});